import { set, reduce } from 'lodash';

import {
    FulfillmentMethods,
    fulfillmentMethodsConstants,
    fulfillmentMethodsUtils,
    defaultFulfillmentMethods,
} from '@skunexus/order-decision-rules-form';

const { AVAILABLE_METHODS, METHODS_CONFIG, WAREHOUSES_OPTION } = fulfillmentMethodsConstants;

export default {
    name: 'nikeOrderDecisionRules',
    before: [],
    after: [],
    setup: (app) => {
        const nikeOrderDecisionActionName = 'nike_order_decision_action';
        const interofficeFulfillmentMethodCode = 'InterofficeMail';

        const routeName = 'orderDecisionRuleForm';
        const route = app.routes.getItem(routeName);
        if (route) {
            const customActionComponents = {
                [nikeOrderDecisionActionName]: FulfillmentMethods,
            };

            const customActionUtils = {
                [nikeOrderDecisionActionName]: fulfillmentMethodsUtils,
            };

            const customPropsForFulfillmentMethods = {
                availableMethods: [...AVAILABLE_METHODS, interofficeFulfillmentMethodCode],
                methodsConfig: {
                    ...METHODS_CONFIG,
                    [interofficeFulfillmentMethodCode]: {
                        code: interofficeFulfillmentMethodCode,
                        buttonLabel: 'Add Warehouse for Interoffice',
                        label: 'Warehouse for Interoffice',
                        options: WAREHOUSES_OPTION,
                        fieldName: 'warehouse_id',
                    },
                },
            };

            const customActionProps = {
                ...reduce(
                    defaultFulfillmentMethods,
                    (result, methodCode) => {
                        set(result, methodCode, { ...customPropsForFulfillmentMethods });
                        return result;
                    },
                    {},
                ),
                [nikeOrderDecisionActionName]: { ...customPropsForFulfillmentMethods },
            };
            const routeProps = route.props;
            route.props = (state) => ({
                ...routeProps(state),
                customActionComponents,
                customActionUtils,
                customActionProps,
            });
            app.routes.changeItem(routeName, route);
        }
    },
};
